import * as React from 'react';

import {Button} from 'shells/button/button';
import {colors} from 'shells/colors/colors';
// @ts-expect-error
import {LoadingIcon} from 'shells/icon/svg/loading-icon';
import {FooterBar} from 'shells/modal/footer-bar';

type Props = {
    onCancel: () => void;
    onContinue: () => void;
    primaryButtonText?: string;
    primaryButtonLoadingText?: string;
    primaryButtonLoading?: boolean;
    primaryButtonDisabled?: boolean;
};

export function InteractionModalFooter(props: Props) {
    return (
        <FooterBar
            absolutePosition={true}
            left={
                <Button variant='text-secondary' size='big' onClick={props.onCancel}>
                    Cancel
                </Button>
            }
            right={
                <Button
                    variant='primary'
                    size='big'
                    onClick={props.onContinue}
                    disabled={props.primaryButtonLoading || props.primaryButtonDisabled}
                >
                    {props.primaryButtonLoading ? (
                        <div className='flex gap-4 align-center'>
                            {props.primaryButtonLoadingText || 'Adding'}
                            <div className='mt-4'>
                                <LoadingIcon size={15} fill={colors.white} />
                            </div>
                        </div>
                    ) : (
                        props.primaryButtonText || 'Continue'
                    )}
                </Button>
            }
        />
    );
}
